import React from "react";
import { Label, Input } from "reactstrap";
import { ITextField } from "../../../interfaces/Index";

import "./TextField.scss";

const TextField: React.FC<ITextField> = (props: ITextField) => {
  return (
    <div className="form-group">
      <Label className="block text-uppercase label">
        {props.label}{" "}
        {props.isOptional ? <span className="optional">(optional)</span> : ""}
      </Label>
      <Input
        id={props.id}
        name={props.name}
        type={props.type}
        value={props.value}
        className={props.className}
        placeholder={props.placeholder}
        onChange={props.handleChange}
        disabled={props.disabled}
        pattern={props.validator}
        required={!props.isOptional}
        onFocus={props.onFocus}
        maxLength={props.maxLength}
        onKeyPress={props.onKeyPress}
        autoFocus={props.autoFocus}
        onWheel={props.onWheel}
      />
      <div className="error-message label">
        {props.error ? <strong>Note: </strong> : null}
        {props.error}
      </div>
    </div>
  );
};

TextField.defaultProps = {
  autoFocus: false,
  className: "form-control",
  isOptional: false,
};

export default TextField;
